import { ICON__rotate_solid } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { use_generation_current_price } from '@/hooks/use_generation_current_price';
import i18n_page_generation from '@/locales/keys/i18n_page_generation.json';
import { ViewShortcutTrigger } from '@/pages/_base/shortcut_hint/ViewShortcutTrigger';
import { HOOK_GENERATION__start_with_new_seeds } from '@/pages/page_generation/view_header/_buttons/button_generation/_hooks/HOOK_GENERATION__start_with_new_seeds';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { EShortcutType } from '@shared/dto/hint_shortcuts/e_shortcut_type';
import { useTranslation } from 'react-i18next';
import { G_VIEW_generation_price_determining } from '../_views/G_VIEW_generation_price_determining';

export function G_BUTTON__generation_start_with_new_seeds() {
  /*
   * STORE
   */
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_GENERATION);

  const { generation_current_price } = use_generation_current_price(false);

  const { generation_start_with_new_seeds, can_start_generation_with_new_seeds } = HOOK_GENERATION__start_with_new_seeds();

  /*
   * HTML
   */

  if (Number.isNaN(generation_current_price)) return <G_VIEW_generation_price_determining />;

  return (
    <ViewShortcutTrigger hint_shortcut_keys={[EShortcutType.GENERATION_START]}>
      <UI_PRIMITIVE__button
        disabled={!can_start_generation_with_new_seeds}
        className="size-full"
        variant="no-border-on-bar"
        onClick={() => generation_start_with_new_seeds(false)}
        title={t(i18n_page_generation.sidebar_user_input.button.generation_start_with_new_seeds.title, { price: generation_current_price })}
      >
        <ICON__rotate_solid className="size-5 text-purchase" />
      </UI_PRIMITIVE__button>
    </ViewShortcutTrigger>
  );
}
